export const GetInTouch = [
  { title: "About Us", link: "" },
  { title: "Careers", link: "" },
  { title: "Press Releases", link: "" },
];

export const Connections = [
  { title: "Facebook", link: "" },
  { title: "Twitter", link: "" },
  { title: "Instagram", link: "" },
  { title: "YouTube", link: "" },
  { title: "linkedin", link: "" },
];

export const Earnings = [
  { title: "Become an Affiliate", link: "" },
  { title: "Advertise your product", link: "" },
  { title: "Sell on Market", link: "" },
];

export const Account = [
  { title: "Your account", link: "" },
  { title: "Returns Centre", link: "" },
  { title: "100% purchase protection", link: "" },
  { title: "Chat with us", link: "" },
  { title: "Help", link: "" },
];

export const tagsData = [
  "Beans",
  "Carrots",
  "Apples",
  "Carlic",
  "Mushrooms",
  "Chilli",
  "Broccoli",
  "Watermelons",
  "Oranges",
  "Bananas",
  "Grapes",
  "Cherries",
  "Meat",
  "Seo",
  "Fish",
  "Seo",
  "Fresh",
  "Lemons",
  "Beans",
];
export const ProductData = {
  freshness: "New (Extra fresh)",
  farm: "Grocery Farm Fields",
  delivery: "Europe",
  stock: "320 pcs",
};

export const Cost = {
  cost: "Free Shipping",
  duration: "Delivery in 1 day",
};
